import { PageView } from "../../components"
import { UserContext } from "../../hooks/UserContext"
import { fetchHomeSummary } from "../../services/storeServices"
import { useQuery } from "react-query"
import { useContext } from "react"
import { MetricsContainer } from "./MetricsContainer"
import { OrderStatsContainer } from "./OrderStatsContainer"
import SelfOnboarding from "./SelfOnboarding"
import { useTranslation } from "react-i18next"
import { Title } from "@tremor/react"
import { Link } from "react-router-dom"

export const Home = () => {
    const { user } = useContext(UserContext)
    const { t } = useTranslation()
    const pdf = require('../../pages/Home/CalendarioNavidad2024.pdf')
    const {
        isLoading,
        // isError: isError,
        // error,
        data: onboardingData,
        // isFetching,
        // isPreviousData,
        refetch,
    } = useQuery(["home_info", user.current_store?.id], () => fetchHomeSummary(user.current_store?.id), {
        staleTime: 1000 * 60 * 1, // after 1min, refetch if screen is focused
    })

    const onReloadData = () => {
        refetch()
    }

    return (
        <PageView>
            <section>
                <div className="mt-1 mb-5">
                    <Title className="font-semibold text-black !text-xl">{t("home.title", { store_name: user.current_store?.name })}</Title>
                </div>
            </section>

            {onboardingData && onboardingData["onboarding_data"] && onboardingData["onboarding_data"]["requires_onboarding"] && (
                <section>
                    <SelfOnboarding
                        onboardingData={onboardingData && onboardingData["onboarding_data"]}
                        showLoader={isLoading}
                        onReloadData={() => onReloadData()}
                    />
                </section>
            )}
            {user.current_store?.warehouses[0]?.country === "MX" && (
                <section>
                    <div className="rounded-lg bg-yellow-200 text-yellow-700 p-7 mb-10 mt-5 flex flex-col">
                        <h4 className="font-medium text-lg">¡Se acerca Hot Sale! Ten en cuenta:</h4>
                        <ul className="list-disc pl-5 marker:text-yellow-700 mt-2">
                            <li>No se procesarán recibos de inventario del 10 de mayo al 10 de junio</li>
                            <li>Pedidos REM, maquilas y logística inversa cerrarán del 24 de mayo al 8 de junio</li>
                        </ul>
                        <p className="mt-2">
                            ¡Ayúdanos a llenar tu forecast{' '}
                            <a
                                href="https://forms.gle/4CWv27UBUNYAXpid7"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="underline hover:text-yellow-800 font-medium transition-colors"
                            >
                                acá
                            </a>!
                        </p>
                    </div>
                </section>
            )}


            {/* {user.current_store?.warehouses[0]?.country === "BR" && (
                 <section>
                    <div className="rounded-lg bg-yellow-200 text-yellow-700 p-7 mb-10 mt-5 flex flex-col">
                        <div> 📢 ATENÇÃO: PROGRAMAÇÃO OPERACIONAL DE FINAL DE ANO 📢 </div>
                        <br></br>
                        <div>📅 Dezembro:</div>
                        <div>
                            <li>23 e 30/12: Operação reduzida (50%) | 08h às 18h</li>
                            <li>24 e 31/12: Horário e operação reduzida (50%) | 07h às 15h</li>
                            <li>25/12: Sem operação</li>
                            <li>Demais dias do mês: Operação normal</li>
                        </div>
                           <br></br>
                        <div>📅 Janeiro:</div>
                        <div>
                            <li>01/01/2024: Sem operação</li>
                        </div>
                        <br></br>
                        <div>
                            🔔 Planeje-se com antecedência! 🚛
                        </div>
                   </div>
                </section>
            )} */}
            {/*
            {user.current_store?.warehouses[0]?.country === "BR" && (
                 <section>
                    <div className="rounded-lg bg-yellow-200 text-yellow-700 p-7 mb-10 mt-5 flex flex-col">
                        <div> Atenção, parceiro Cubbo! 🎉 </div>
                        <br></br>
                        <div>
                            Nossos horários operacionais <b>não sofrerão alterações</b> durante o Carnaval! Mas vale sempre lembrar dos prazos operacionais e de suporte para evitar qualquer imprevisto.
                        </div>
                        <br></br>

                        <div>
                            Ficou com dúvida? Consulte nossa seção de Perguntas Frequentes ou entre em contato com nosso time de suporte: <a href="https://faq.cubbo.com/hc/pt-br/requests/new">https://faq.cubbo.com/hc/pt-br/requests/new</a>
                        </div>
                        <br></br>

                        <div>
                            Bom Carnaval! 🥳
                        </div>
                   </div>
                </section>
            )}
*/}

            {/* {user.current_store?.warehouses[0]?.country === "BR" && (
                <section>
                    <div className="rounded-lg bg-yellow-200 text-yellow-700 p-7 mb-10 mt-5 flex flex-col">
                        <div>🚨 Aviso sobre possíveis atrasos nas coletas </div>
                        <br></br>
                        <div>
                            Informamos que, devido a um acidente na Rodovia Régis Bittencourt na data de ontem, que causou interdições e trânsito intenso, algumas coletas podem sofrer atrasos hoje.
                            Estamos acompanhando a situação de perto e fazendo o possível para minimizar os impactos.
                            Contamos com sua compreensão e seguimos à disposição!
                        </div>
                        <br></br>
                        <div>
                            Equipe Cubbo
                        </div>
                    </div>
                </section>
            )} */}

            <section>
                <OrderStatsContainer storeId={user.current_store?.id} />
            </section>

            <section>
                <MetricsContainer storeId={user.current_store?.id} />
            </section>
        </PageView>
    )
}
